import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.printer',
    modules: [
        R,
    ],
})
@Service('PrinterStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('printers');
    }

    remove () {
        return this.endpoint.remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/printer.js